import courseService from '../../../../../mylibrary/services/courseService';

enum FilterValues {
    status = 'status',
    published = 'PUBLISHED',
    contentType = 'contentType',
    studyMaterial = 'studymaterial',
}

export let preSelectedFilter = {
    contentMenu: "all",
    goalsDriller: {},
    ommitSubjectDetails: false,
    excludedIds: [],
    contentFilterData: [{
        filterValue: FilterValues.contentType,
        isSelected: true,
        disabled: false,
        filters: []
    },
    {
        filterValue: FilterValues.status,
        isSelected: true,
        filters: [{
            filterValue: FilterValues.published,
            isSelected: true,
            filters: []
        }],
    }
    ]

}

const getContentTypeSubCode = (code: any) => {
    switch (code) {
        case 'chapterTests':
            return 'chap'
        case 'conceptTests':
            return 'concept';
        case 'mainTests':
            return 'full'
        case 'sampleTests':
            return 'sample'
        case 'scheduledTests':
            return 'full,part,combined'
        case 'video':
            return 'videos'
        case 'studyNotes':
            return 'note'
        case 'formulas':
            return 'formulas'
    }
}

export const setGoalsDriller = (
    allGoals: any,
    courseType: any,
    handleSetState: Function,
    preSelectedFilterData: any,
    conceptPhaseData: any,
    handlePreFiltersData: Function,
    getPackageByIdData: any,
    treeData: any,
    masterIdOfSubject?: string,
    masterIdOfChapter?: string,
    masterIdOfConcept?: string,
) => {
    let level = 'course';
    let goalsDriller: any = {};
    let clonePreSelectedFilter: any = {};
    const courseData = allGoals.filter((ele: any) => ele.courseType.id === courseType.id)
    if (courseData && courseData.length) {
        goalsDriller = {
            level,
            course: {
                ...courseData[0]
            },
        };
        clonePreSelectedFilter = JSON.parse(JSON.stringify(preSelectedFilterData));
        clonePreSelectedFilter = { ...clonePreSelectedFilter, goalsDriller: { ...goalsDriller } };
        const { contentPreferences = {} } = getPackageByIdData;
        const contentPreferencesKeys = Object.keys(contentPreferences);
        let contentSubType = '';
        let contentSubTypeCode = '';
        let testpapers = ['conceptTests'];
        let studymaterial = ['video', 'formulas', 'studyNotes'];
        let flag = 0;
        let flagForStudymaterial = 0;
        contentPreferencesKeys && contentPreferencesKeys.length && contentPreferencesKeys.forEach((ele: any) => {
            if (contentPreferences[ele] && contentPreferences[ele].enabled) {
                if (testpapers.includes(ele) && !flag) {
                    !contentSubType.length ? (contentSubType = 'testpapers') : (contentSubType = contentSubType + "," + 'testpapers')
                    flag++;
                }
                if (studymaterial.includes(ele) && !flagForStudymaterial) {
                    !contentSubType.length ? (contentSubType = 'studymaterial') : (contentSubType = contentSubType + "," + 'studymaterial')
                    flagForStudymaterial++;
                }
                if (testpapers.includes(ele)) {
                    const getType: any = getContentTypeSubCode(ele);
                    !contentSubTypeCode.length ? (contentSubTypeCode = getType) : (contentSubTypeCode = contentSubTypeCode + "," + getType)
                }
                if (studymaterial.includes(ele)) {
                    const getType: any = getContentTypeSubCode(ele);
                    !contentSubTypeCode.length ? (contentSubTypeCode = getType) : (contentSubTypeCode = contentSubTypeCode + "," + getType)
                }
            }
        });
        const contentFilter = setContentFilters(contentSubType, contentSubTypeCode);
        clonePreSelectedFilter.contentFilterData[0] = JSON.parse(JSON.stringify(contentFilter));
        clonePreSelectedFilter = { ...clonePreSelectedFilter, contentTypeCode: contentSubType, contentSubTypeCode }
        courseService.getCourseSubject(courseData[0]._id).then((subjects: any) => {
            if (masterIdOfSubject && subjects && subjects.length) {
                level = 'subject'
                const filteredSubject = subjects.filter((sub: any) => sub.masterIDs.includes(masterIdOfSubject));
                clonePreSelectedFilter = {

                    ...clonePreSelectedFilter,
                    goalsDriller: {
                        ...clonePreSelectedFilter.goalsDriller,
                        level,
                        subject: { ...filteredSubject[0] }
                    }
                }
                courseService.getCourseSubSubject(courseData[0]._id, filteredSubject[0]._id).then((subSubjectData: any) => {
                    let chaptersData: any = []
                    subSubjectData.forEach((subSubject: any, indexOfSubject: number) => {
                        courseService.getCourseChapters(courseData[0]._id, subSubject._id).then((chapters: any) => {
                            if (chapters && chapters.length) {
                                const filterChapter = chapters.filter((chapter: any) => chapter.masterIDs.includes(masterIdOfChapter));
                                if (filterChapter && filterChapter.length) {
                                    courseService.getCourseConcepts(courseData[0]._id, filteredSubject[0]._id, filterChapter[0]._id).then((concepts: any) => {
                                        const filterConcept = concepts.filter((chapter: any) => chapter.masterIDs.includes(masterIdOfConcept));
                                        level = 'concept';
                                        clonePreSelectedFilter = {
                                            ...clonePreSelectedFilter,
                                            goalsDriller: {
                                                ...clonePreSelectedFilter.goalsDriller,
                                                subSubject: { ...subSubjectData[indexOfSubject] },
                                                chapter: { ...filterChapter[0] },
                                                concept: { ...filterConcept[0] },
                                                level
                                            }
                                        }
                                        const excludedIds = getContentDataIds(treeData, conceptPhaseData);
                                        clonePreSelectedFilter = {
                                            ...clonePreSelectedFilter,
                                            excludedIds
                                        };
                                        handleSetState({
                                            preSelectedFilter: clonePreSelectedFilter
                                        });
                                        const { subjectIndex, weekIndex, phaseIndex, chapterIndex, conceptIndex } = conceptPhaseData;
                                        if(conceptPhaseData.hasOwnProperty('conceptIndex')){ 
                                        handlePreFiltersData([`${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}-${conceptIndex}`], clonePreSelectedFilter)
                                       }else if(conceptPhaseData.hasOwnProperty('chapterIndex')){
                                         handlePreFiltersData([`${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}`], clonePreSelectedFilter)
                                       }
                                    })
                                }
                            }
                        });
                    })
                })
            }
        });
    }
};

export const getContentDataIds = (treeData: any, conceptPhaseData: any) => {
    let cloneTree = JSON.parse(JSON.stringify(treeData));
    const { phases = [] } = treeData;
    const clonePhases = JSON.parse(JSON.stringify(phases));
    const { subjectIndex, weekIndex, phaseIndex, chapterIndex, conceptIndex } = conceptPhaseData;
    let ids = [];
  if(conceptPhaseData.hasOwnProperty('conceptIndex')){  
    ids = clonePhases[phaseIndex]['weeks'][weekIndex]
    ['subjects'][subjectIndex]['chapters'][chapterIndex]
    ['concepts'][conceptIndex]['content'] =
        clonePhases[phaseIndex]['weeks'][weekIndex]
        ['subjects'][subjectIndex]['chapters'][chapterIndex]
        ['concepts'][conceptIndex]['content'].map((ele: any) => ele.id);
  }else if(conceptPhaseData.hasOwnProperty('chapterIndex')){
  try{
    ids = clonePhases[phaseIndex]['weeks'][weekIndex]
    ['subjects'][subjectIndex]['chapters'][chapterIndex]['content'] =
        clonePhases[phaseIndex]['weeks'][weekIndex]
        ['subjects'][subjectIndex]['chapters'][chapterIndex]['content'].map((ele: any) => ele.id);
  }catch(err){
     console.log({err});
   }
  }
    return ids;
}

const setContentFilters = (contentType: any, contentSubTypeCode: any) => {
    const initialFilter: any = {
        filterValue: FilterValues.contentType,
        isSelected: true,
        disabled: false,
        filters: []
    };

    const contentTypeValue = contentType ? contentType.split(',') : [];
    const contentSubTypeCodeValue = contentSubTypeCode ? contentSubTypeCode.split(',') : [];
    let newFilter = [];
    let cloneFilter = JSON.parse(JSON.stringify(initialFilter));
    contentTypeValue && contentTypeValue.length && contentTypeValue.forEach((conType: any, index: number) => {
        let insideFilterStructure = { ...JSON.parse(JSON.stringify(initialFilter)) };
        insideFilterStructure = { ...JSON.parse(JSON.stringify(insideFilterStructure)), filterValue: conType };
        cloneFilter.filters.push(insideFilterStructure);
        contentSubTypeCodeValue && contentSubTypeCodeValue.length && contentSubTypeCodeValue.forEach((subType: any) => {
            let insideFilterSubTypeStructure = JSON.parse(JSON.stringify(initialFilter));
            if (conType === 'testpapers' && (subType === 'concept')) {
                insideFilterSubTypeStructure = { ...insideFilterSubTypeStructure, filterValue: subType }
                cloneFilter.filters[index].filters.push(insideFilterSubTypeStructure)
            }
            if (conType === 'studymaterial' && (subType === 'videos' || subType === 'note' || subType === 'formulas')) {
                insideFilterSubTypeStructure = { ...insideFilterSubTypeStructure, filterValue: subType }
                cloneFilter.filters[index].filters.push(insideFilterSubTypeStructure);
            }
        });
    });
    return cloneFilter;
} 

export const defaultDisplaySetting={
    showPhases: true,
    showWeeks: true,
    showChapters: true,
    showConcepts: true,
    showTestVisibility: true,
}